import { EstructuraBase } from './estructura-base';

export class FormDropdown extends EstructuraBase<string> {
    controlType = 'dropdown';
    options: { key: string, value: string }[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
    }
}
